import React, { useState, useEffect } from 'react';
import styles from './SessionTimeoutWarning.module.css';

interface SessionTimeoutWarningProps {
  timeRemaining: number; // Minutes remaining
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  timeRemaining,
  onStayLoggedIn,
  onLogout,
}) => {
  const [countdown, setCountdown] = useState(timeRemaining);

  useEffect(() => {
    setCountdown(timeRemaining);
    
    const interval = setInterval(() => {
      setCountdown((prev) => {
        const newCount = Math.max(0, prev - 1);
        if (newCount === 0) {
          clearInterval(interval);
        }
        return newCount;
      });
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [timeRemaining]);

  const minutes = Math.floor(countdown);
  const isExpiringSoon = countdown <= 2;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Session Expiring Soon</h2>
        </div>
        <div className={styles.content}>
          <p>
            Your session will expire in{' '}
            <span className={isExpiringSoon ? styles.warning : styles.time}>
              {minutes} {minutes === 1 ? 'minute' : 'minutes'}
            </span>
            .
          </p>
          <p className={styles.message}>
            Would you like to stay logged in?
          </p>
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            onClick={onStayLoggedIn}
            className={styles.stayButton}
          >
            Stay Logged In
          </button>
          <button
            type="button"
            onClick={onLogout}
            className={styles.logoutButton}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

